import React, { useState, useEffect, useRef, useCallback } from 'react';
import HomeNavbar from '../components/HomeNavbar';
import StoreModal from '../components/StoreModal';
import Toast from '../components/Toast';
import { useAuth } from '../contexts/AuthContext';
import { getSessionTicket } from '../services/api';
import './HomePage.css';

// Game data
const games = [
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/bg001.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/bg002.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/bg003.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/bg004.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/bg005.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep001.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep002.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep003.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep004.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep005.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep006.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep007.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep008.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep009.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep010.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep011.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep012.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep013.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep014.png' },
    { image: 'https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep015.png' }
];

// Sports data
const sports = [
    { image: 'https://mediumrare.imgix.net/soccer-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/basketball-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/tennis-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/baseball-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/ice-hockey-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/american-football-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/mma-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/boxing-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/golf-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/racing-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/cricket-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/rugby-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/volleyball-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/handball-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/darts-en.png?w=180&h=236&fit=min&auto=format' },
    { image: 'https://mediumrare.imgix.net/snooker-en.png?w=180&h=236&fit=min&auto=format' }
];

// basename for URL routing (SEO friendly)
const BASENAME = 'sportsbook';

const HomePage = () => {
    const { user, isLoading, refreshWallet, wallet, setShowLoginModal, currentMode, switchMode, logout, setOnLoginSuccess } = useAuth();
    const [viewAllStates, setViewAllStates] = useState({
        sports: false,
        games: true
    });
    const [showStore, setShowStore] = useState(false);
    const [toast, setToast] = useState({ show: false, message: '' });
    
    // iframe related states
    const [iframeUrl, setIframeUrl] = useState('');
    const [showIframe, setShowIframe] = useState(false);
    const [isLoadingSportbook, setIsLoadingSportbook] = useState(false);
    const iframeRef = useRef(null);
    const prevWalletRef = useRef(null);
    const hasOpenedRef = useRef(false);
    const isFetchingRef = useRef(false);
    // 保存上次的 SDK URL，用于刷新时复用
    const lastSdkUrlRef = useRef('');

    const toggleViewAll = (type) => {
        setViewAllStates(prev => ({
            ...prev,
            [type]: !prev[type]
        }));
    };

    // Parse sport path from URL (supports both basename and bt-path)
    const getSportPath = useCallback(() => {
        // First check for basename path: /sportsbook/xxx
        const pathMatch = window.location.pathname.match(new RegExp(`^/${BASENAME}(/.*)?$`));
        if (pathMatch) {
            return pathMatch[1] || '/';
        }
        // Fallback to bt-path query parameter for backward compatibility
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get('bt-path') || sessionStorage.getItem('betby-restore-path') || '/';
    }, []);

    // Build SDK URL with sport path
    const buildSdkUrl = useCallback((baseUrl, sportPath) => {
        const urlObj = new URL(baseUrl);
        // Use basename style URL: add path after basename
        const cleanPath = sportPath.startsWith('/') ? sportPath : `/${sportPath}`;
        urlObj.pathname = `/${BASENAME}${cleanPath}`;
        return urlObj.toString();
    }, []);

    // Internal function to open sportbook without checking loading state
    const doOpenSportBook = useCallback(async () => {
        // Double check to prevent duplicate calls
        if (isFetchingRef.current) {
            console.log('[doOpenSportBook] Already fetching, skip');
            return;
        }
        
        isFetchingRef.current = true;
        console.log('[doOpenSportBook] Fetching session ticket...');
        
        try {
            const gameCurrencyAlias = currentMode === 'gc' ? 'GC' : 'SC';
            const ticketData = await getSessionTicket(
                user?.email || 'test@abc.com', 
                user?.user_id || '7S8P',
                gameCurrencyAlias
            );
            
            if (ticketData.sdk_url) {
                // Use basename URL routing
                let sdkUrl = ticketData.sdk_url;
                console.log('[HomePage] Original SDK URL:', sdkUrl);
                
                const sportPath = getSportPath();
                sessionStorage.removeItem('betby-restore-path');
                
                // Build URL with basename
                sdkUrl = buildSdkUrl(sdkUrl, sportPath);
                
                console.log('[HomePage] Final SDK URL:', sdkUrl);
                
                // Save URL to ref for reuse on refresh
                lastSdkUrlRef.current = sdkUrl;
                sessionStorage.setItem('betby-last-sdk-url', sdkUrl);
                sessionStorage.setItem('betby-last-sport-path', sportPath);
                
                // Update host page URL with basename (no refresh)
                const currentPath = window.location.pathname;
                const targetPath = `/${BASENAME}${sportPath.startsWith('/') ? sportPath : `/${sportPath}`}`;
                if (window.history && currentPath !== targetPath) {
                    window.history.pushState({ betbyOpen: true, sportPath }, '', targetPath);
                }
                
                setIframeUrl(sdkUrl);
                setShowIframe(true);
            } else {
                throw new Error('No SDK URL received');
            }
        } catch (error) {
            // Handle 400 error: token invalid, need to logout
            if (error.code === 400 || (error.message && error.message.includes('400'))) {
                console.log('[doOpenSportBook] Token invalid (400), logging out...');
                showToastMessage('Session expired, please login again');
                // Close iframe if open
                setShowIframe(false);
                setIframeUrl('');
                hasOpenedRef.current = false;
                // Clean up URL
                if (window.history && window.location.pathname.startsWith(`/${BASENAME}`)) {
                    window.history.replaceState({}, '', '/');
                }
                sessionStorage.removeItem('betby-last-sport-path');
                sessionStorage.removeItem('betby-last-sdk-url');
                sessionStorage.removeItem('betby-restore-path');
                // Logout and show login
                await logout();
            } else {
                // Other errors throw
                throw error;
            }
        } finally {
            isFetchingRef.current = false;
        }
    }, [user, currentMode, logout, getSportPath, buildSdkUrl]);

    const openSportBook = useCallback(async (targetPath = null) => {
        // Prevent duplicate calls
        if (isLoadingSportbook || hasOpenedRef.current) {
            return;
        }
        
        // If target path specified, update URL
        if (targetPath) {
            const cleanPath = targetPath.startsWith('/') ? targetPath : `/${targetPath}`;
            const fullPath = `/${BASENAME}${cleanPath}`;
            window.history.pushState({ betbyOpen: true, sportPath: cleanPath }, '', fullPath);
        }
        
        try {
            setIsLoadingSportbook(true);
            hasOpenedRef.current = true;
            await doOpenSportBook();
        } catch (error) {
            console.error('Failed to open sportbook:', error);
            showToastMessage('Failed to open sportsbook');
            hasOpenedRef.current = false;
            
            // If token error (400), clean URL to prevent loop
            if (error.message && (error.message.includes('token') || error.code === 400)) {
                console.log('[OpenSportBook] Token error, clearing sport path from URL');
                if (window.history && window.location.pathname.startsWith(`/${BASENAME}`)) {
                    window.history.replaceState({}, '', '/');
                }
                // Clean saved path
                sessionStorage.removeItem('betby-last-sport-path');
                sessionStorage.removeItem('betby-last-sdk-url');
            }
        } finally {
            setIsLoadingSportbook(false);
        }
    }, [isLoadingSportbook, doOpenSportBook]);

    // Send message to SDK
    const sendMessageToSDK = useCallback((type, data) => {
        if (iframeRef.current?.contentWindow) {
            console.log('宿主调用postmessage发送给sdk:', { type, data });
            iframeRef.current.contentWindow.postMessage({ type, data }, '*');
        }
    }, []);

    // Handle Betby navigation - update URL without refresh
    const handleBetbyNavigate = useCallback((url) => {
        console.log('[Betby Navigate] Received URL:', url);
        
        if (!url || !window.history) return;
        
        try {
            const urlObj = new URL(url);
            // Support both basename path and bt-path parameter
            let sportPath = null;
            
            // Check for basename path: /sportsbook/xxx
            const pathMatch = urlObj.pathname.match(new RegExp(`/${BASENAME}(/.*)?$`));
            if (pathMatch) {
                sportPath = pathMatch[1] || '/';
            } else {
                // Fallback to bt-path query parameter
                sportPath = urlObj.searchParams.get('bt-path');
            }
            
            console.log('[Betby Navigate] sport path:', sportPath);
            
            if (sportPath) {
                // Save sport path (for restore on back)
                sessionStorage.setItem('betby-last-sport-path', sportPath);
                
                // Build new URL with basename
                const cleanPath = sportPath.startsWith('/') ? sportPath : `/${sportPath}`;
                const newPath = `/${BASENAME}${cleanPath}`;
                
                console.log('[Betby Navigate] Updating URL to:', newPath);
                
                // Update browser URL without refresh
                window.history.pushState({ betbyNav: true, sportPath }, '', newPath);
            }
        } catch (error) {
            console.error('[Betby Navigate] Error parsing URL:', error);
        }
    }, []);

    // Switch currency mode and notify SDK
    const handleSwitchMode = useCallback((mode) => {
        switchMode(mode);
        // Notify SDK about currency change
        const moneyType = mode === 'gc' ? [1] : [0];
        sendMessageToSDK('MoneyType', moneyType);
    }, [switchMode, sendMessageToSDK]);

    // Close store modal and notify SDK
    const handleCloseStore = useCallback(() => {
        setShowStore(false);
        sendMessageToSDK('WalletData', { action: 'closeShop' });
        // TODO: Remove after SDK migrates to WalletData
        sendMessageToSDK('sport_balance_update', { action: 'closeShop' });
    }, [sendMessageToSDK]);

    const closeIframe = useCallback(() => {
        // Save current sport path for restore on return
        const currentPath = window.location.pathname;
        if (currentPath.startsWith(`/${BASENAME}`)) {
            const sportPath = currentPath.replace(new RegExp(`^/${BASENAME}`), '') || '/';
            sessionStorage.setItem('betby-last-sport-path', sportPath);
            console.log('[CloseIframe] Saved sport path for restore:', sportPath);
        }
        
        setShowIframe(false);
        setIframeUrl('');
        hasOpenedRef.current = false;
        
        // Close: clean URL and return to host home
        if (window.history && window.location.pathname.startsWith(`/${BASENAME}`)) {
            window.history.pushState({ betbyClose: true }, '', '/');
        }
    }, []);

    const showComingSoon = () => {
        showToastMessage('Coming Soon!');
    };

    const showToastMessage = (message) => {
        setToast({ show: true, message });
        setTimeout(() => {
            setToast({ show: false, message: '' });
        }, 3000);
    };

    // Browser back/forward button handling
    useEffect(() => {
        const handlePopState = (event) => {
            console.log('[PopState]', event.state, window.location.pathname);
            const currentPath = window.location.pathname;
            const isSportPage = currentPath.startsWith(`/${BASENAME}`);
            
            // If not on sport page and iframe is showing, close it
            if (!isSportPage && showIframe) {
                console.log('[PopState] Not on sport page, closing iframe');
                closeIframe();
            }
            
            // If on sport page and iframe not showing, reopen
            if (isSportPage && !showIframe && !hasOpenedRef.current) {
                const sportPath = currentPath.replace(new RegExp(`^/${BASENAME}`), '') || '/';
                console.log('[PopState] On sport page but iframe closed, reopening...');
                sessionStorage.setItem('betby-restore-path', sportPath);
                openSportBook();
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [showIframe, closeIframe, openSportBook]);

    // Set up login success callback to refresh iframe URL
    useEffect(() => {
        setOnLoginSuccess((loggedInUser) => {
            console.log('[Login Success] User logged in, refreshing SDK URL...');
            
            // Check if there's an intended path to restore
            const intendedPath = sessionStorage.getItem('betby-intended-path');
            if (intendedPath) {
                console.log('[Login Success] Restoring intended path:', intendedPath);
                sessionStorage.removeItem('betby-intended-path');
                // Navigate to the intended path
                window.history.replaceState({ betbyOpen: true }, '', intendedPath);
                // Open sportbook with the intended path
                openSportBook();
                return;
            }
            
            // If iframe is open, refresh its URL without reopening
            if (showIframe) {
                doOpenSportBook();
            }
        });
    }, [setOnLoginSuccess, showIframe, doOpenSportBook, openSportBook]);

    // Handle pending restore when user loads after page refresh
    useEffect(() => {
        const pendingRestore = sessionStorage.getItem('betby-pending-restore');
        if (user && pendingRestore && !showIframe && !hasOpenedRef.current) {
            console.log('[Pending Restore] User loaded, restoring sportbook:', pendingRestore);
            sessionStorage.removeItem('betby-pending-restore');
            
            const sportPath = pendingRestore.replace(new RegExp(`^/${BASENAME}`), '') || '/';
            
            // Try to reuse last SDK URL
            const lastUrl = sessionStorage.getItem('betby-last-sdk-url') || lastSdkUrlRef.current;
            
            if (lastUrl) {
                try {
                    const urlObj = new URL(lastUrl);
                    const cleanPath = sportPath.startsWith('/') ? sportPath : `/${sportPath}`;
                    urlObj.pathname = `/${BASENAME}${cleanPath}`;
                    const newUrl = urlObj.toString();
                    
                    lastSdkUrlRef.current = newUrl;
                    sessionStorage.setItem('betby-last-sdk-url', newUrl);
                    sessionStorage.setItem('betby-last-sport-path', sportPath);
                    
                    setIframeUrl(newUrl);
                    setShowIframe(true);
                    hasOpenedRef.current = true;
                } catch (error) {
                    console.error('[Pending Restore] Failed:', error);
                    openSportBook();
                }
            } else {
                openSportBook();
            }
        }
    }, [user, showIframe, openSportBook]);

    // Restore state after page refresh
    useEffect(() => {
        const currentPath = window.location.pathname;
        const isSportPage = currentPath.startsWith(`/${BASENAME}`);
        
        // If not on sport page, skip
        if (!isSportPage) {
            console.log('[Restore] Not on sport page, skip restoring');
            return;
        }
        
        // If iframe already open, skip
        if (showIframe || hasOpenedRef.current) {
            console.log('[Restore] Iframe already open, skip restoring');
            return;
        }
        
        // If auth is still loading, wait
        if (isLoading) {
            console.log('[Restore] Auth loading, will retry when complete');
            sessionStorage.setItem('betby-pending-restore', currentPath);
            return;
        }
        
        // If user not logged in, redirect to home and show login
        if (!user) {
            console.log('[Restore] User not logged in, redirecting to home');
            // Save the path they were trying to access
            sessionStorage.setItem('betby-intended-path', currentPath);
            // Redirect to home page
            window.history.replaceState({}, '', '/');
            // Show login modal
            setShowLoginModal(true);
            return;
        }
        
        // Clear pending restore
        sessionStorage.removeItem('betby-pending-restore');
        
        const sportPath = currentPath.replace(new RegExp(`^/${BASENAME}`), '') || '/';
        console.log('[Restore] Restoring sportbook with path:', sportPath);
        
        // Try to reuse last SDK URL
        const lastUrl = sessionStorage.getItem('betby-last-sdk-url') || lastSdkUrlRef.current;
        
        if (lastUrl) {
            // Reuse last URL, only update sport path
            try {
                const urlObj = new URL(lastUrl);
                const cleanPath = sportPath.startsWith('/') ? sportPath : `/${sportPath}`;
                urlObj.pathname = `/${BASENAME}${cleanPath}`;
                const newUrl = urlObj.toString();
                
                console.log('[Restore] Reusing last URL, new URL:', newUrl);
                
                // Update ref and sessionStorage
                lastSdkUrlRef.current = newUrl;
                sessionStorage.setItem('betby-last-sdk-url', newUrl);
                sessionStorage.setItem('betby-last-sport-path', sportPath);
                
                // Open directly without calling getSessionTicket
                setIframeUrl(newUrl);
                setShowIframe(true);
                hasOpenedRef.current = true;
            } catch (error) {
                console.error('[Restore] Failed to reuse last URL:', error);
                // Fallback to calling API
                openSportBook();
            }
        } else {
            // No last URL, need to call API
            console.log('[Restore] No last URL found, calling openSportBook');
            openSportBook();
        }
        
        // Save state before refresh
        const handleBeforeUnload = () => {
            if (showIframe) {
                const currentPath = window.location.pathname;
                if (currentPath.startsWith(`/${BASENAME}`)) {
                    sessionStorage.setItem('betby-refresh-path', currentPath);
                }
            }
        };
        
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showIframe, openSportBook, user]);

    // Handle SDK postMessage events
    useEffect(() => {
        const handleSdkMessage = (event) => {
            // TODO: Production - verify event.origin for security
            // if (event.origin !== 'https://your-sdk-domain.com') return;
            
            const message = event.data;
            
            // Check if it's SDK message format
            if (message && message.type) {
                console.log('宿主监听到sdk的postmessage:', { type: message.type, data: message.data });
                
                switch (message.type) {
                    case 'LoggedOut':
                        // SDK logged out - close iframe
                        closeIframe();
                        break;
                        
                    case 'TurnShop':
                        // SDK recharge triggered - open store modal
                        setShowStore(true);
                        break;
                        
                    case 'SDKLogin':
                        // SDK login triggered - show login modal on top of iframe
                        setShowLoginModal(true);
                        break;
                        
                    case 'MoneyType':
                        // SDK currency mode changed
                        // message.data is array: [1] for GC, [0] for SC
                        if (message.data && Array.isArray(message.data)) {
                            const mode = message.data[0] === 1 ? 'gc' : 'sc';
                            console.log('[MoneyType] Switching to mode:', mode);
                            if (mode !== currentMode) {
                                handleSwitchMode(mode);
                            }
                        }
                        break;
                        
                    case 'GetWallet':
                        // SDK requests wallet refresh
                        console.log('[GetWallet] Refreshing wallet...');
                        if (user?.user_id) {
                            refreshWallet();
                        }
                        break;
                        
                    // Handle Betby navigation message
                    case 'BetbyNavigate':
                        // Format: { type, data: { url } }
                        const navigateUrl = message.data?.url;
                        console.log('[BetbyNavigate]', navigateUrl);
                        if (navigateUrl) {
                            handleBetbyNavigate(navigateUrl);
                        }
                        break;
                        
                    // Handle Betby URL change (via MutationObserver)
                    case 'BetbyUrlChange':
                        // Format: { type, data: { url } }
                        const urlChange = message.data?.url;
                        console.log('[BetbyUrlChange]', urlChange);
                        if (urlChange) {
                            handleBetbyNavigate(urlChange);
                        }
                        break;
                        
                    default:
                        console.log('[SDK Unknown Message]:', message.type);
                }
            }
        };

        window.addEventListener('message', handleSdkMessage);
        
        return () => {
            window.removeEventListener('message', handleSdkMessage);
        };
    }, [closeIframe, setShowLoginModal, handleSwitchMode, currentMode, user, refreshWallet, handleBetbyNavigate]);

    // Monitor wallet changes and notify SDK
    useEffect(() => {
        if (showIframe && iframeRef.current && wallet && prevWalletRef.current) {
            // Check if wallet balance changed
            const prevWallet = prevWalletRef.current;
            const hasChanged = 
                wallet.coin !== prevWallet.coin ||
                wallet.ts_money !== prevWallet.ts_money ||
                wallet.game_cash !== prevWallet.game_cash ||
                wallet.rd_money !== prevWallet.rd_money;

            if (hasChanged) {
                // Send WalletData message to SDK
                sendMessageToSDK('WalletData', { 
                    coin: wallet.coin,
                    ts_money: wallet.ts_money,
                    gm_money: wallet.gm_money,
                    rd_money: wallet.rd_money
                });
                // TODO: Remove after SDK migrates to WalletData
                sendMessageToSDK('sport_balance_update', { 
                    coin: wallet.coin,
                    ts_money: wallet.ts_money,
                    gm_money: wallet.gm_money,
                    rd_money: wallet.rd_money
                });
            }
        }
        prevWalletRef.current = wallet;
    }, [wallet, showIframe, sendMessageToSDK]);

    const displaySports = viewAllStates.sports ? sports : sports.slice(0, 8);
    const displayGames = viewAllStates.games ? games : games.slice(0, 8);

    return (
        <div className="homepage">
            <HomeNavbar 
                onOpenStore={() => setShowStore(true)}
            />
            
            <main className="main-content">
                <section className="hero-section">
                    <h1 className="hero-title">Premium Gaming Experience</h1>
                    <p className="hero-subtitle">
                        Discover the ultimate gaming platform with cutting-edge technology 
                        and unparalleled entertainment
                    </p>
                </section>

                <section className="section">
                    <div className="section-header">
                        <h2 className="section-title">Trending Sports</h2>
                        <div 
                            className="view-all-btn" 
                            onClick={() => toggleViewAll('sports')}
                        >
                            {viewAllStates.sports ? 'Collapse' : 'View All'}
                        </div>
                    </div>
                    <div className="sports-grid">
                        {displaySports.map((sport, index) => (
                            <div 
                                key={index} 
                                className="sport-card"
                                onClick={() => {
                                    // Check for saved sport path, restore if exists
                                    const savedPath = sessionStorage.getItem('betby-last-sport-path');
                                    if (savedPath) {
                                        console.log('[OpenSport] Restoring to saved path:', savedPath);
                                        openSportBook(savedPath);
                                    } else {
                                        openSportBook();
                                    }
                                }}
                            >
                                <img 
                                    src={sport.image} 
                                    alt="Sport" 
                                    className="sport-image" 
                                    loading="lazy" 
                                />
                            </div>
                        ))}
                    </div>
                </section>

                <section className="section">
                    <div className="section-header">
                        <h2 className="section-title">Trending Games</h2>
                        <div 
                            className="view-all-btn" 
                            onClick={() => toggleViewAll('games')}
                        >
                            {viewAllStates.games ? 'Collapse' : 'View All'}
                        </div>
                    </div>
                    <div className="games-grid">
                        {displayGames.map((game, index) => (
                            <div 
                                key={index} 
                                className="game-card"
                                onClick={showComingSoon}
                            >
                                <img 
                                    src={game.image} 
                                    alt="Game" 
                                    className="game-image" 
                                    loading="lazy" 
                                />
                            </div>
                        ))}
                    </div>
                </section>
            </main>

            {/* Full-screen iframe overlay */}
            {showIframe && (
                <div className="iframe-overlay">
                    {/* Iframe Header */}
                    <div className="iframe-header">
                        <button className="iframe-back-btn" onClick={closeIframe}>
                            &lt;
                        </button>
                        <div className="iframe-logo">
                            <img src="/winburst-logo.png" alt="WinBurst" />
                            <span>WinBurst</span>
                        </div>
                        <div className="iframe-right">
                            <div className="iframe-mode-toggle">
                                <button 
                                    className={`iframe-mode-btn ${currentMode === 'gc' ? 'active' : ''}`}
                                    onClick={() => handleSwitchMode('gc')}
                                >
                                    GC
                                </button>
                                <button 
                                    className={`iframe-mode-btn ${currentMode === 'sc' ? 'active' : ''}`}
                                    onClick={() => handleSwitchMode('sc')}
                                >
                                    SC
                                </button>
                            </div>
                            <div className="iframe-balance" onClick={() => setShowStore(true)}>
                                <span className="iframe-balance-amount">
                                    {currentMode === 'gc' 
                                        ? (wallet?.coin || 0).toLocaleString() 
                                        : ((wallet?.ts_money || 0) + (wallet?.rd_money || 0) + (wallet?.gm_money || 0)).toFixed(2)
                                    }
                                </span>
                                <span className="iframe-balance-currency">{currentMode.toUpperCase()}</span>
                                <span className="iframe-add-btn">+</span>
                            </div>
                        </div>
                    </div>
                    <iframe
                        ref={iframeRef}
                        src={iframeUrl}
                        title="Sportbook"
                        className="sportbook-iframe"
                        allow="fullscreen"
                    />
                </div>
            )}

            <StoreModal 
                isOpen={showStore}
                onClose={handleCloseStore}
            />
            
            <Toast 
                show={toast.show}
                message={toast.message}
                onClose={() => setToast({ show: false, message: '' })}
            />
        </div>
    );
};

export default HomePage;
